
export default class Router {
    constructor(controllers, defaultController) {
        this.controllers = controllers;
        this.defaultController = null;
        this.lastPage = null;
        this.page = null;
        this.onRoute = function (path, pageId) { };
        window.addEventListener('hashchange', () => {
            //could clear hash to avoid requiring multi back button presses
            //history.replaceState(null, null, ' ');
            const path = window.location.hash.substr(1); //.substr(1) remove hash
            this.route(path);
        }, false);
    }
    navigate(path, model) {

        //back button is not needed from browser any more
        //hardware back button is covered by cordova

        //  if (history.pushState) {
        //      history.pushState(null, null, "#" + path);
        //  } else {
        //      window.location.hash = path; //location.hash = triggers addEventListener('hashchange') and double routes
        //  }
        this.route(path, model);
    }
    route(path, model) {
        const lastPage = this.lastPage;

        //get page
        path = path.replace(/^\/+/g, ''); //remove leading slash
        let pageId = path.split("/")[0];

        //map pageId to controller if needed
        if (!pageId) pageId = "MainMenu";

        //trigger last controller for clean up
        const lastController = this.getController(lastPage);
        if (lastController && lastController.hide) lastController.hide(path, model);

        //trigger controller show
        const controller = this.getController(pageId);
        if (controller && controller.show) controller.show(path, model);

        this.page = pageId;
        this.path = path;
        this.lastPage = lastPage;

        if (this.onRoute) this.onRoute(path, pageId);
    }
    getController(controllerId) {
        let controller = this.controllers[controllerId];
        return controller || this.defaultController;
    }
}